import { differenceInHours, differenceInMinutes } from 'date-fns';
import moment from 'moment';

export const formatDate = (date: Date | string, withTime?: TimeRanges) => {
  const day = new Date(date).toLocaleDateString('fr-FR');
  const time = new Date(date).toLocaleTimeString([], {
    hour: '2-digit',
    minute: '2-digit'
  });
  return withTime ? day + ' ' + time : day;
};

export const getDaysAndHoursLeft = end => {
  const today = new Date();
  const res = differenceInHours(new Date(moment(end).format()), today);
  const minutesLeft = differenceInMinutes(
    new Date(moment(end).format()),
    today
  );
  if (res <= 0) {
    if (minutesLeft <= 0) {
      return 'Terminé';
    }
    return `${minutesLeft} minute(s)`;
  }
  const nbDays = Math.floor(res / 24);
  if (nbDays === 0) {
    return `${nbDays} jour(s) et ${res} heure(s)`;
  } else {
    const nbHours = (res - nbDays * 24) % 24;
    return `${nbDays} jour(s) et ${nbHours} heure(s)`;
  }
};

export const todayIsBetween = (debut, fin) => {
  return new Date() > new Date(debut) && new Date() < new Date(fin);
};
